import request from "@/utils/request";
// import { getToken } from "@/utils/auth"; // get token
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
const formInstanceAPI = configR.envConfigs.FLOWINSTANCE_API_URL;

// 获取服务名称
export function getFfName(params) {
  return request({
    url: `${formInstanceAPI}api/v1/flow/v1/application/getFfName`,
    method: "get",
    params: params
  });
}
// 查询实例列表
export function getQueryInstanceList(params) {
  return request({
    url: `${formInstanceAPI}api/v1/flow/v1/application/queryInstanceList`,
    method: "get",
    params: params
  });
}

// 查询服务分页列表
export function getServiceInstanceList(params) {
  return request({
    url: `${API}api/proxy/service/api/common/appservice/pageByCloud`,
    method: "get",
    params: params
  });
}
// 获取部门
export function getDepartment(params) {
  return request({
    url: `${API}api/proxy/service/api/common/appservice/findDep`,
    method: "get",
    params: params
  });
}
// 获取业务域
export function getBusinessDomain(code) {
  return request({
    url: `${API}api/proxy/service/api/common/service/tagging/lable/${code}`,
    method: "get"
  });
}
//cms管理列表
export function findAllContent(data) {
  return request({
    url: `${API}v2/cms/release/findAllContent?endTime=${data.endTime}&keyWord=${data.keyWord}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&startTime=${data.startTime}&status=${data.status}`,
    method: "get",
  });
}
//草稿列表
export function caogaoContent(data) {
  return request({
    url: `${API}v2/cms/release/getDraftList?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
    method: "get",
  });
}
// 删除草稿
export function deleteContent(data) {
  return request({
    url: `${API}v2/cms/content/deleteOne`,
    method: "delete",
    headerType: "portal",
    params: data
  });
}
//获取栏目下拉
export function getColumnSelectList() {
  return request({
    url: `${API}v2/cms/content/findColByUser`,
    method: "get",
    headerType: "portal"
  });
}
//获取流程模版
export function workConList() {
  return request({
    url: `${formInstanceAPI}api/v1/flow/workCon/list?yyzid=1b82748f-a38e-44f8-85cd-5d6369d198d5`,
    method: "get",
    headerType: "admin"
  });
}
//资讯详情
export function getDetailsData(id) {
  return request({
    url: `${API}v1/cms/content/getOne?id=${id}`,
    method: "get",
    headerType: "portal"
  });
}
//https://portal-service.nwpu.edu.cn/v2/cms/manage/changeRelease?id=2ca909d5-9e83-4e6f-b3af-dcc2c4752115&reviewStatus=2

//change news release status
export function cancelPublishNews(id) {
  return request({
    url: `${API}v2/cms/manage/changeRelease?id=${id}&reviewStatus=2`,
    method: "put",
    headerType: "portal"
  });
}
// CMS可管理的部门-栏目
// //v2/cms/getCanManangerColumnList
export function getCanMananger() {
  return request({
    url: `${API}/v2/cms/getCanManangerColumnList`,
    method: "get",
    headerType: "portal"
  });
}
export function changeTop(data) {
  return request({
    url: `${API}v2/cms/content/changeTop`,
    method: "put",
    headerType: "portal",
    params: data
  });
}